// src/components/ReferralTracker.tsx
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { setStoredReferralCode } from "../utils/referral";

const ReferralTracker: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);

    // Support common variants: ?ref=, ?referral=, ?referralCode=
    const raw =
      params.get("ref") ||
      params.get("referral") ||
      params.get("referralCode");

    const code = raw?.trim();
    if (!code) return;

    setStoredReferralCode(code);

    // Optional (only if you have a click endpoint):
    // - intentionally NOT calling any endpoint here to avoid breaking or noisy 404s.
    // - if you want, we can add an endpoint call later once you confirm the backend route.
  }, [location.search]);

  return null;
};

export default ReferralTracker;
